// extracted by mini-css-extract-plugin
export var formContainer = "_m4-0";
export var message = "_m4-1";